module.exports = __webpack_public_path__ + "img/0Q3B8790-7_H_WoodMatted_MockedUp.d1ccc43b.jpg";